import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const FashionDesigningCoursePage: React.FC = () => {
  const courseData = {
    title: "Bachelor of Fashion Designing",
    shortName: "B.F.D.",
    duration: "3-4 years",
    description: "Creative program focused on fashion design, textile technology, and apparel manufacturing",
    overview: "Bachelor of Fashion Designing (B.F.D.) is a 3-4 year undergraduate program that combines creativity with technical skills in fashion design, garment construction, textile science, and fashion marketing. This course covers fashion illustration, pattern making, draping, textile design, fashion merchandising, and industry practices, preparing students for careers in the fashion and apparel industry.",
    eligibility: [
      "10+2 from any stream (Arts/Science/Commerce)",
      "Minimum 50% marks in 12th standard",
      "Portfolio submission and creative aptitude test",
      "Some colleges require entrance exam (NIFT, PEARL, AIEED)"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Fundamentals of Design",
          "Fashion Illustration",
          "Textile Science",
          "History of Costume",
          "Color Theory",
          "Basic Pattern Making"
        ]
      },
      {
        year: 2,
        subjects: [
          "Garment Construction",
          "Draping Techniques",
          "Computer-Aided Design (CAD)",
          "Fashion Photography",
          "Surface Ornamentation",
          "Fashion Marketing"
        ]
      },
      {
        year: 3,
        subjects: [
          "Advanced Pattern Making",
          "Fashion Merchandising",
          "Retail Management",
          "Accessory Design",
          "Fashion Forecasting",
          "Portfolio Development"
        ]
      },
      {
        year: 4,
        subjects: [
          "Fashion Styling",
          "Entrepreneurship",
          "Fashion Show Production",
          "Internship/Industry Training",
          "Final Collection Project",
          "Fashion Business Management"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Fashion Designer",
        "Textile Designer",
        "Fashion Stylist",
        "Fashion Illustrator",
        "Pattern Maker",
        "Fashion Merchandiser",
        "Fashion Buyer",
        "Fashion Photographer",
        "Costume Designer",
        "Fashion Entrepreneur"
      ],
      industries: [
        "Fashion Houses",
        "Textile Industry",
        "Retail Brands",
        "Export Houses",
        "Film & Television",
        "Theater Productions",
        "Fashion Magazines",
        "E-commerce Platforms",
        "Fashion Consulting",
        "Luxury Brands"
      ],
      averageSalary: "₹3-6 LPA (Fresher), ₹8-25 LPA (Experienced)",
      topRecruiters: [
        "Myntra, Flipkart Fashion",
        "Reliance Trends, Pantaloons",
        "Raymond, Peter England",
        "Sabyasachi, Manish Malhotra",
        "Fabindia, Global Desi",
        "Lifestyle, Shoppers Stop"
      ]
    },

    admissionProcess: [
      "NIFT Entrance Exam (National Institute of Fashion Technology)",
      "PEARL Academy Entrance Test",
      "AIEED (All India Entrance Exam for Design)",
      "State-level design entrance exams",
      "Portfolio-based direct admissions",
      "Management quota admissions"
    ],

    topColleges: [
      {
        name: "National Institute of Fashion Technology (NIFT)",
        location: "New Delhi/Chennai/Mumbai",
        fees: "₹2,50,000 - ₹4,00,000",
        ranking: "Premier Fashion Institute"
      },
      {
        name: "Pearl Academy",
        location: "Delhi/Mumbai/Jaipur",
        fees: "₹6,00,000 - ₹8,00,000",
        ranking: "Top Private Fashion School"
      },
      {
        name: "Symbiosis Institute of Design",
        location: "Pune",
        fees: "₹4,50,000",
        ranking: "NIRF Design Ranking: 15"
      },
      {
        name: "Indian Institute of Art and Design",
        location: "New Delhi",
        fees: "₹7,50,000",
        ranking: "Leading Design Institute"
      }
    ],

    skills: [
      "Fashion Illustration",
      "Pattern Making",
      "Garment Construction",
      "Color Coordination",
      "Textile Knowledge",
      "CAD Software (Adobe Illustrator, Photoshop)",
      "Fashion Forecasting",
      "Trend Analysis",
      "Creative Thinking",
      "Business Acumen"
    ],

    futureScope: "Excellent prospects with growing fashion industry, rise of sustainable fashion, digital fashion technology, and increasing demand for Indian designers globally.",

    faqs: [
      {
        question: "Do I need to have drawing skills to pursue fashion designing?",
        answer: "Basic drawing skills are helpful but not mandatory. Fashion illustration can be learned during the course. More important are creativity, visual sense, and passion for fashion."
      },
      {
        question: "What is the scope of fashion designing in India?",
        answer: "India's fashion industry is rapidly growing with opportunities in ready-to-wear, luxury fashion, export business, and digital fashion platforms. The industry is valued at over $75 billion."
      },
      {
        question: "Can I start my own fashion brand after completing the course?",
        answer: "Yes, many graduates start their own labels. The course covers entrepreneurship and business aspects of fashion, preparing you for independent ventures."
      },
      {
        question: "What about international career opportunities?",
        answer: "Fashion designing offers global opportunities. Indian designers are increasingly recognized internationally, and you can work with international brands or start global ventures."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0a183d] via-black to-[#1a2746] flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow animate-glow mb-8 text-center">
        {courseData.title}
      </h1>
      <div className="w-full max-w-5xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default FashionDesigningCoursePage;
